module.exports = __webpack_public_path__ + "img/4.ba4ea8e5.png";